import actions from './actions';

const {
  GET_DATA_DOCUMENTS,
  GET_DATA_BEGIN,
  GET_DATA_FINISH,
  SET_DATA_DOCUMENTS,
  SET_DATA_NEW_DOCUMENT,
} = actions;

const initialState = {
  data: [],
  total: 0,
  loading: false,
};

const documentsReducer = (state = initialState, action:any) => {
  const { type, data } = action;
  switch (type) {
    case GET_DATA_DOCUMENTS:
      return {
        ...state
      };
    case GET_DATA_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_DATA_FINISH:
      return {
        ...state,
        loading: false,
      };
    case SET_DATA_DOCUMENTS:
      return {
        ...state,
        data: data.results,
        total: data.totalResults,
        loading: false,
      };
    case SET_DATA_NEW_DOCUMENT:
      return {
        ...state,
        data: [data, ...state.data],
      };
    default:
      return state;
  }
};
export { documentsReducer };
